export enum ShopItemFieldsEnum {
  name = 'name',
  url = 'url',
  industryIds = 'industryIds',
  shopPlatformId = 'shopPlatformId',
  otherPlatformName = 'otherPlatformName',
  shopIds = 'shopIds',
  currencyCode = 'currencyCode',
}
